import type { GameDraft } from '../../../../shared/drafts';
import type { PublishedGame } from '../../../../shared/publications';
import { UFO_RULES, type UfoTimingMode } from '../../../../shared/ufoRules';
export type UfoChoice = { id: string; label: string; correct: boolean; mediaUrl?: string };
export type UfoQuestion = { id: string; prompt: string; mediaUrl?: string; approachMs: number; choices: UfoChoice[] };
export type UfoConfig = { id: string; timingMode: UfoTimingMode; questions: UfoQuestion[] };
export function draftToUfoConfig(source: Pick<GameDraft | PublishedGame, 'id' | 'timingMode' | 'questions' | 'maxLevels'>): UfoConfig {
  return { id: source.id, timingMode: source.timingMode ?? 'per-question', questions: Array.from({ length: source.maxLevels }, (_, i) => {
    const q = source.questions.find(q => q.levels[0] === i + 1);
    if (!q) throw new Error(`${i + 1}. UFO sorusu bulunamadı.`);
    return { id: q.id, prompt: q.prompt, mediaUrl: q.media?.url,
      approachMs: (q.timeLimitSeconds ?? UFO_RULES.defaultApproachSeconds) * 1000,
      choices: q.choices.map(c => ({ id: c.id, label: c.text, correct: c.isCorrect, mediaUrl: c.media?.url })) };
  }) };
}
